export const FREQUENCY = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Semi-weekly', value: 'semi-weekly' },
  { label: 'Monthly', value: 'monthly' },
  { label: 'Semi-monthly', value: 'semi-monthly' },
];

export const TREATMENT_RESPONSE = ['Positive improvement', 'No progress', 'Unfavorable outcome'];

export enum ERecordShared {
  'Shared' = 'Shared',
  'Will be shared' = 'Will be shared',
}
export enum EResponseToTreatment {
  'Positive improvement' = 'Positive improvement',
  'No progress' = 'No progress',
  'Unfavorable outcome' = 'Unfavorable outcome',
}
export enum EFrequency {
  'daily' = 'daily',
  'weekly' = 'weekly',
  'semi-weekly' = 'semi-weekly',
  'monthly' = 'monthly',
  'semi-monthly' = 'semi-monthly',
}

export const errorStateConstants = {
  services: 'services',
  noService: 'noService',
};

export const COLLABORATION_OF_CARE_TEXT = {
  authorized:
    'Collaboration of care is the organization of the client care between all of the participants/stakeholders/providers involved with their treatment and will take place as needed throughout the 6-month authorization period. Consent was obtained to support ongoing communication related to the implementation of therapeutic interventions and client progress.',
  unauthorized:
    "Collaboration of care is the organization of the Client's care between all participants/stakeholders/providers involved with the Client's treatment. At the time of intake, either the Client's caregiver requested not to release information with a specific medical provider or did not provide Authorization to Release Information.",
};
